import * as ee from "react";
import qr, { forwardRef as Gr, useContext as At, useState as Nt } from "react";
import { globalColor as X, illaPrefix as Q, applyBoxStyle as kt, deleteCssProps as It } from "@illa-design/theme";
import { css as ze } from "@emotion/react";
import { isObject as Dt } from "@illa-design/system";
var ir = { exports: {} }, Ee = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ar;
function Mt() {
  if (Ar)
    return Ee;
  Ar = 1;
  var e = qr, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(l, p, v) {
    var d, y = {}, P = null, N = null;
    v !== void 0 && (P = "" + v), p.key !== void 0 && (P = "" + p.key), p.ref !== void 0 && (N = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (y[d] = p[d]);
    if (l && l.defaultProps)
      for (d in p = l.defaultProps, p)
        y[d] === void 0 && (y[d] = p[d]);
    return { $$typeof: r, type: l, key: P, ref: N, props: y, _owner: o.current };
  }
  return Ee.Fragment = n, Ee.jsx = f, Ee.jsxs = f, Ee;
}
var ge = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nr;
function Ft() {
  return Nr || (Nr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = qr, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), l = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), P = Symbol.for("react.lazy"), N = Symbol.for("react.offscreen"), $ = Symbol.iterator, g = "@@iterator";
    function k(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = $ && t[$] || t[g];
      return typeof s == "function" ? s : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(t) {
      {
        for (var s = arguments.length, u = new Array(s > 1 ? s - 1 : 0), m = 1; m < s; m++)
          u[m - 1] = arguments[m];
        S("error", t, u);
      }
    }
    function S(t, s, u) {
      {
        var m = _.ReactDebugCurrentFrame, w = m.getStackAddendum();
        w !== "" && (s += "%s", u = u.concat([w]));
        var I = u.map(function(x) {
          return String(x);
        });
        I.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, I);
      }
    }
    var D = !1, c = !1, V = !1, A = !1, Je = !1, Re;
    Re = Symbol.for("react.module.reference");
    function Ke(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || Je || t === o || t === v || t === d || A || t === N || D || c || V || typeof t == "object" && t !== null && (t.$$typeof === P || t.$$typeof === y || t.$$typeof === f || t.$$typeof === l || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === Re || t.getModuleId !== void 0));
    }
    function He(t, s, u) {
      var m = t.displayName;
      if (m)
        return m;
      var w = s.displayName || s.name || "";
      return w !== "" ? u + "(" + w + ")" : u;
    }
    function Ce(t) {
      return t.displayName || "Context";
    }
    function q(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case v:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var s = t;
            return Ce(s) + ".Consumer";
          case f:
            var u = t;
            return Ce(u._context) + ".Provider";
          case p:
            return He(t, t.render, "ForwardRef");
          case y:
            var m = t.displayName || null;
            return m !== null ? m : q(t.type) || "Memo";
          case P: {
            var w = t, I = w._payload, x = w._init;
            try {
              return q(x(I));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var H = Object.assign, re = 0, Te, Oe, le, Pe, de, $e, Ae;
    function Ne() {
    }
    Ne.__reactDisabledLog = !0;
    function Ze() {
      {
        if (re === 0) {
          Te = console.log, Oe = console.info, le = console.warn, Pe = console.error, de = console.group, $e = console.groupCollapsed, Ae = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Ne,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function Xe() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: H({}, t, {
              value: Te
            }),
            info: H({}, t, {
              value: Oe
            }),
            warn: H({}, t, {
              value: le
            }),
            error: H({}, t, {
              value: Pe
            }),
            group: H({}, t, {
              value: de
            }),
            groupCollapsed: H({}, t, {
              value: $e
            }),
            groupEnd: H({}, t, {
              value: Ae
            })
          });
        }
        re < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var pe = _.ReactCurrentDispatcher, he;
    function ne(t, s, u) {
      {
        if (he === void 0)
          try {
            throw Error();
          } catch (w) {
            var m = w.stack.trim().match(/\n( *(at )?)/);
            he = m && m[1] || "";
          }
        return `
` + he + t;
      }
    }
    var ve = !1, ae;
    {
      var Qe = typeof WeakMap == "function" ? WeakMap : Map;
      ae = new Qe();
    }
    function h(t, s) {
      if (!t || ve)
        return "";
      {
        var u = ae.get(t);
        if (u !== void 0)
          return u;
      }
      var m;
      ve = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var I;
      I = pe.current, pe.current = null, Ze();
      try {
        if (s) {
          var x = function() {
            throw Error();
          };
          if (Object.defineProperty(x.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(x, []);
            } catch (Z) {
              m = Z;
            }
            Reflect.construct(t, [], x);
          } else {
            try {
              x.call();
            } catch (Z) {
              m = Z;
            }
            t.call(x.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Z) {
            m = Z;
          }
          t();
        }
      } catch (Z) {
        if (Z && m && typeof Z.stack == "string") {
          for (var b = Z.stack.split(`
`), W = m.stack.split(`
`), M = b.length - 1, F = W.length - 1; M >= 1 && F >= 0 && b[M] !== W[F]; )
            F--;
          for (; M >= 1 && F >= 0; M--, F--)
            if (b[M] !== W[F]) {
              if (M !== 1 || F !== 1)
                do
                  if (M--, F--, F < 0 || b[M] !== W[F]) {
                    var B = `
` + b[M].replace(" at new ", " at ");
                    return t.displayName && B.includes("<anonymous>") && (B = B.replace("<anonymous>", t.displayName)), typeof t == "function" && ae.set(t, B), B;
                  }
                while (M >= 1 && F >= 0);
              break;
            }
        }
      } finally {
        ve = !1, pe.current = I, Xe(), Error.prepareStackTrace = w;
      }
      var se = t ? t.displayName || t.name : "", $r = se ? ne(se) : "";
      return typeof t == "function" && ae.set(t, $r), $r;
    }
    function me(t, s, u) {
      return h(t, !1);
    }
    function oe(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function te(t, s, u) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return h(t, oe(t));
      if (typeof t == "string")
        return ne(t);
      switch (t) {
        case v:
          return ne("Suspense");
        case d:
          return ne("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return me(t.render);
          case y:
            return te(t.type, s, u);
          case P: {
            var m = t, w = m._payload, I = m._init;
            try {
              return te(I(w), s, u);
            } catch {
            }
          }
        }
      return "";
    }
    var ke = Object.prototype.hasOwnProperty, Er = {}, gr = _.ReactDebugCurrentFrame;
    function Ie(t) {
      if (t) {
        var s = t._owner, u = te(t.type, t._source, s ? s.type : null);
        gr.setExtraStackFrame(u);
      } else
        gr.setExtraStackFrame(null);
    }
    function lt(t, s, u, m, w) {
      {
        var I = Function.call.bind(ke);
        for (var x in t)
          if (I(t, x)) {
            var b = void 0;
            try {
              if (typeof t[x] != "function") {
                var W = Error((m || "React class") + ": " + u + " type `" + x + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[x] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw W.name = "Invariant Violation", W;
              }
              b = t[x](s, x, m, u, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (M) {
              b = M;
            }
            b && !(b instanceof Error) && (Ie(w), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", m || "React class", u, x, typeof b), Ie(null)), b instanceof Error && !(b.message in Er) && (Er[b.message] = !0, Ie(w), E("Failed %s type: %s", u, b.message), Ie(null));
          }
      }
    }
    var dt = Array.isArray;
    function er(t) {
      return dt(t);
    }
    function pt(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, u = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return u;
      }
    }
    function ht(t) {
      try {
        return br(t), !1;
      } catch {
        return !0;
      }
    }
    function br(t) {
      return "" + t;
    }
    function _r(t) {
      if (ht(t))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", pt(t)), br(t);
    }
    var ye = _.ReactCurrentOwner, vt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, xr, Sr, rr;
    rr = {};
    function mt(t) {
      if (ke.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function yt(t) {
      if (ke.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Et(t, s) {
      if (typeof t.ref == "string" && ye.current && s && ye.current.stateNode !== s) {
        var u = q(ye.current.type);
        rr[u] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', q(ye.current.type), t.ref), rr[u] = !0);
      }
    }
    function gt(t, s) {
      {
        var u = function() {
          xr || (xr = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: u,
          configurable: !0
        });
      }
    }
    function bt(t, s) {
      {
        var u = function() {
          Sr || (Sr = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        u.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: u,
          configurable: !0
        });
      }
    }
    var _t = function(t, s, u, m, w, I, x) {
      var b = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: u,
        props: x,
        // Record the component responsible for creating this element.
        _owner: I
      };
      return b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(b, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: m
      }), Object.defineProperty(b, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    };
    function xt(t, s, u, m, w) {
      {
        var I, x = {}, b = null, W = null;
        u !== void 0 && (_r(u), b = "" + u), yt(s) && (_r(s.key), b = "" + s.key), mt(s) && (W = s.ref, Et(s, w));
        for (I in s)
          ke.call(s, I) && !vt.hasOwnProperty(I) && (x[I] = s[I]);
        if (t && t.defaultProps) {
          var M = t.defaultProps;
          for (I in M)
            x[I] === void 0 && (x[I] = M[I]);
        }
        if (b || W) {
          var F = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          b && gt(x, F), W && bt(x, F);
        }
        return _t(t, b, W, w, m, ye.current, x);
      }
    }
    var tr = _.ReactCurrentOwner, wr = _.ReactDebugCurrentFrame;
    function ie(t) {
      if (t) {
        var s = t._owner, u = te(t.type, t._source, s ? s.type : null);
        wr.setExtraStackFrame(u);
      } else
        wr.setExtraStackFrame(null);
    }
    var nr;
    nr = !1;
    function ar(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function Rr() {
      {
        if (tr.current) {
          var t = q(tr.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function St(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), u = t.lineNumber;
          return `

Check your code at ` + s + ":" + u + ".";
        }
        return "";
      }
    }
    var Cr = {};
    function wt(t) {
      {
        var s = Rr();
        if (!s) {
          var u = typeof t == "string" ? t : t.displayName || t.name;
          u && (s = `

Check the top-level render call using <` + u + ">.");
        }
        return s;
      }
    }
    function Tr(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var u = wt(s);
        if (Cr[u])
          return;
        Cr[u] = !0;
        var m = "";
        t && t._owner && t._owner !== tr.current && (m = " It was passed a child from " + q(t._owner.type) + "."), ie(t), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', u, m), ie(null);
      }
    }
    function Or(t, s) {
      {
        if (typeof t != "object")
          return;
        if (er(t))
          for (var u = 0; u < t.length; u++) {
            var m = t[u];
            ar(m) && Tr(m, s);
          }
        else if (ar(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = k(t);
          if (typeof w == "function" && w !== t.entries)
            for (var I = w.call(t), x; !(x = I.next()).done; )
              ar(x.value) && Tr(x.value, s);
        }
      }
    }
    function Rt(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var u;
        if (typeof s == "function")
          u = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === y))
          u = s.propTypes;
        else
          return;
        if (u) {
          var m = q(s);
          lt(u, t.props, "prop", m, t);
        } else if (s.PropTypes !== void 0 && !nr) {
          nr = !0;
          var w = q(s);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ct(t) {
      {
        for (var s = Object.keys(t.props), u = 0; u < s.length; u++) {
          var m = s[u];
          if (m !== "children" && m !== "key") {
            ie(t), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", m), ie(null);
            break;
          }
        }
        t.ref !== null && (ie(t), E("Invalid attribute `ref` supplied to `React.Fragment`."), ie(null));
      }
    }
    function Pr(t, s, u, m, w, I) {
      {
        var x = Ke(t);
        if (!x) {
          var b = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (b += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var W = St(w);
          W ? b += W : b += Rr();
          var M;
          t === null ? M = "null" : er(t) ? M = "array" : t !== void 0 && t.$$typeof === r ? (M = "<" + (q(t.type) || "Unknown") + " />", b = " Did you accidentally export a JSX literal instead of a component?") : M = typeof t, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", M, b);
        }
        var F = xt(t, s, u, w, I);
        if (F == null)
          return F;
        if (x) {
          var B = s.children;
          if (B !== void 0)
            if (m)
              if (er(B)) {
                for (var se = 0; se < B.length; se++)
                  Or(B[se], t);
                Object.freeze && Object.freeze(B);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Or(B, t);
        }
        return t === a ? Ct(F) : Rt(F), F;
      }
    }
    function Tt(t, s, u) {
      return Pr(t, s, u, !0);
    }
    function Ot(t, s, u) {
      return Pr(t, s, u, !1);
    }
    var Pt = Ot, $t = Tt;
    ge.Fragment = a, ge.jsx = Pt, ge.jsxs = $t;
  }()), ge;
}
process.env.NODE_ENV === "production" ? ir.exports = Mt() : ir.exports = Ft();
var Le = ir.exports;
function jt(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function Vt(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Lt = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Vt(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var f = jt(o);
      try {
        f.insertRule(a, f.cssRules.length);
      } catch (l) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', l);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), Y = "-ms-", Ye = "-moz-", R = "-webkit-", dr = "comm", pr = "rule", hr = "decl", Yt = "@import", Jr = "@keyframes", Wt = "@layer", zt = Math.abs, Ue = String.fromCharCode, Ut = Object.assign;
function Bt(e, r) {
  return L(e, 0) ^ 45 ? (((r << 2 ^ L(e, 0)) << 2 ^ L(e, 1)) << 2 ^ L(e, 2)) << 2 ^ L(e, 3) : 0;
}
function Kr(e) {
  return e.trim();
}
function qt(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function C(e, r, n) {
  return e.replace(r, n);
}
function sr(e, r) {
  return e.indexOf(r);
}
function L(e, r) {
  return e.charCodeAt(r) | 0;
}
function _e(e, r, n) {
  return e.slice(r, n);
}
function J(e) {
  return e.length;
}
function vr(e) {
  return e.length;
}
function De(e, r) {
  return r.push(e), e;
}
function Gt(e, r) {
  return e.map(r).join("");
}
var Be = 1, ue = 1, Hr = 0, z = 0, j = 0, fe = "";
function qe(e, r, n, a, o, i, f) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: Be, column: ue, length: f, return: "" };
}
function be(e, r) {
  return Ut(qe("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Jt() {
  return j;
}
function Kt() {
  return j = z > 0 ? L(fe, --z) : 0, ue--, j === 10 && (ue = 1, Be--), j;
}
function U() {
  return j = z < Hr ? L(fe, z++) : 0, ue++, j === 10 && (ue = 1, Be++), j;
}
function K() {
  return L(fe, z);
}
function Fe() {
  return z;
}
function we(e, r) {
  return _e(fe, e, r);
}
function xe(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Zr(e) {
  return Be = ue = 1, Hr = J(fe = e), z = 0, [];
}
function Xr(e) {
  return fe = "", e;
}
function je(e) {
  return Kr(we(z - 1, cr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Ht(e) {
  for (; (j = K()) && j < 33; )
    U();
  return xe(e) > 2 || xe(j) > 3 ? "" : " ";
}
function Zt(e, r) {
  for (; --r && U() && !(j < 48 || j > 102 || j > 57 && j < 65 || j > 70 && j < 97); )
    ;
  return we(e, Fe() + (r < 6 && K() == 32 && U() == 32));
}
function cr(e) {
  for (; U(); )
    switch (j) {
      case e:
        return z;
      case 34:
      case 39:
        e !== 34 && e !== 39 && cr(j);
        break;
      case 40:
        e === 41 && cr(e);
        break;
      case 92:
        U();
        break;
    }
  return z;
}
function Xt(e, r) {
  for (; U() && e + j !== 47 + 10; )
    if (e + j === 42 + 42 && K() === 47)
      break;
  return "/*" + we(r, z - 1) + "*" + Ue(e === 47 ? e : U());
}
function Qt(e) {
  for (; !xe(K()); )
    U();
  return we(e, z);
}
function en(e) {
  return Xr(Ve("", null, null, null, [""], e = Zr(e), 0, [0], e));
}
function Ve(e, r, n, a, o, i, f, l, p) {
  for (var v = 0, d = 0, y = f, P = 0, N = 0, $ = 0, g = 1, k = 1, _ = 1, E = 0, S = "", D = o, c = i, V = a, A = S; k; )
    switch ($ = E, E = U()) {
      case 40:
        if ($ != 108 && L(A, y - 1) == 58) {
          sr(A += C(je(E), "&", "&\f"), "&\f") != -1 && (_ = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        A += je(E);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        A += Ht($);
        break;
      case 92:
        A += Zt(Fe() - 1, 7);
        continue;
      case 47:
        switch (K()) {
          case 42:
          case 47:
            De(rn(Xt(U(), Fe()), r, n), p);
            break;
          default:
            A += "/";
        }
        break;
      case 123 * g:
        l[v++] = J(A) * _;
      case 125 * g:
      case 59:
      case 0:
        switch (E) {
          case 0:
          case 125:
            k = 0;
          case 59 + d:
            _ == -1 && (A = C(A, /\f/g, "")), N > 0 && J(A) - y && De(N > 32 ? Ir(A + ";", a, n, y - 1) : Ir(C(A, " ", "") + ";", a, n, y - 2), p);
            break;
          case 59:
            A += ";";
          default:
            if (De(V = kr(A, r, n, v, d, o, l, S, D = [], c = [], y), i), E === 123)
              if (d === 0)
                Ve(A, r, V, V, D, i, y, l, c);
              else
                switch (P === 99 && L(A, 3) === 110 ? 100 : P) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ve(e, V, V, a && De(kr(e, V, V, 0, 0, o, l, S, o, D = [], y), c), o, c, y, l, a ? D : c);
                    break;
                  default:
                    Ve(A, V, V, V, [""], c, 0, l, c);
                }
        }
        v = d = N = 0, g = _ = 1, S = A = "", y = f;
        break;
      case 58:
        y = 1 + J(A), N = $;
      default:
        if (g < 1) {
          if (E == 123)
            --g;
          else if (E == 125 && g++ == 0 && Kt() == 125)
            continue;
        }
        switch (A += Ue(E), E * g) {
          case 38:
            _ = d > 0 ? 1 : (A += "\f", -1);
            break;
          case 44:
            l[v++] = (J(A) - 1) * _, _ = 1;
            break;
          case 64:
            K() === 45 && (A += je(U())), P = K(), d = y = J(S = A += Qt(Fe())), E++;
            break;
          case 45:
            $ === 45 && J(A) == 2 && (g = 0);
        }
    }
  return i;
}
function kr(e, r, n, a, o, i, f, l, p, v, d) {
  for (var y = o - 1, P = o === 0 ? i : [""], N = vr(P), $ = 0, g = 0, k = 0; $ < a; ++$)
    for (var _ = 0, E = _e(e, y + 1, y = zt(g = f[$])), S = e; _ < N; ++_)
      (S = Kr(g > 0 ? P[_] + " " + E : C(E, /&\f/g, P[_]))) && (p[k++] = S);
  return qe(e, r, n, o === 0 ? pr : l, p, v, d);
}
function rn(e, r, n) {
  return qe(e, r, n, dr, Ue(Jt()), _e(e, 2, -2), 0);
}
function Ir(e, r, n, a) {
  return qe(e, r, n, hr, _e(e, 0, a), _e(e, a + 1, -1), a);
}
function ce(e, r) {
  for (var n = "", a = vr(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function tn(e, r, n, a) {
  switch (e.type) {
    case Wt:
      if (e.children.length)
        break;
    case Yt:
    case hr:
      return e.return = e.return || e.value;
    case dr:
      return "";
    case Jr:
      return e.return = e.value + "{" + ce(e.children, a) + "}";
    case pr:
      e.value = e.props.join(",");
  }
  return J(n = ce(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function nn(e) {
  var r = vr(e);
  return function(n, a, o, i) {
    for (var f = "", l = 0; l < r; l++)
      f += e[l](n, a, o, i) || "";
    return f;
  };
}
function an(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function on(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var sn = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = K(), o === 38 && i === 12 && (n[a] = 1), !xe(i); )
    U();
  return we(r, z);
}, cn = function(r, n) {
  var a = -1, o = 44;
  do
    switch (xe(o)) {
      case 0:
        o === 38 && K() === 12 && (n[a] = 1), r[a] += sn(z - 1, n, a);
        break;
      case 2:
        r[a] += je(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = K() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += Ue(o);
    }
  while (o = U());
  return r;
}, un = function(r, n) {
  return Xr(cn(Zr(r), n));
}, Dr = /* @__PURE__ */ new WeakMap(), fn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Dr.get(a)) && !o) {
      Dr.set(r, !0);
      for (var i = [], f = un(n, i), l = a.props, p = 0, v = 0; p < f.length; p++)
        for (var d = 0; d < l.length; d++, v++)
          r.props[v] = i[p] ? f[p].replace(/&\f/g, l[d]) : l[d] + " " + f[p];
    }
  }
}, ln = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, dn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", pn = function(r) {
  return r.type === "comm" && r.children.indexOf(dn) > -1;
}, hn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var f = !!n.parent, l = f ? n.parent.children : (
          // global rule at the root level
          o
        ), p = l.length - 1; p >= 0; p--) {
          var v = l[p];
          if (v.line < n.line)
            break;
          if (v.column < n.column) {
            if (pn(v))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, Qr = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, vn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!Qr(n[a]))
      return !0;
  return !1;
}, Mr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, mn = function(r, n, a) {
  Qr(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), Mr(r)) : vn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), Mr(r)));
};
function et(e, r) {
  switch (Bt(e, r)) {
    case 5103:
      return R + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return R + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return R + e + Ye + e + Y + e + e;
    case 6828:
    case 4268:
      return R + e + Y + e + e;
    case 6165:
      return R + e + Y + "flex-" + e + e;
    case 5187:
      return R + e + C(e, /(\w+).+(:[^]+)/, R + "box-$1$2" + Y + "flex-$1$2") + e;
    case 5443:
      return R + e + Y + "flex-item-" + C(e, /flex-|-self/, "") + e;
    case 4675:
      return R + e + Y + "flex-line-pack" + C(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return R + e + Y + C(e, "shrink", "negative") + e;
    case 5292:
      return R + e + Y + C(e, "basis", "preferred-size") + e;
    case 6060:
      return R + "box-" + C(e, "-grow", "") + R + e + Y + C(e, "grow", "positive") + e;
    case 4554:
      return R + C(e, /([^-])(transform)/g, "$1" + R + "$2") + e;
    case 6187:
      return C(C(C(e, /(zoom-|grab)/, R + "$1"), /(image-set)/, R + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return C(e, /(image-set\([^]*)/, R + "$1$`$1");
    case 4968:
      return C(C(e, /(.+:)(flex-)?(.*)/, R + "box-pack:$3" + Y + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + R + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return C(e, /(.+)-inline(.+)/, R + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (J(e) - 1 - r > 6)
        switch (L(e, r + 1)) {
          case 109:
            if (L(e, r + 4) !== 45)
              break;
          case 102:
            return C(e, /(.+:)(.+)-([^]+)/, "$1" + R + "$2-$3$1" + Ye + (L(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~sr(e, "stretch") ? et(C(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (L(e, r + 1) !== 115)
        break;
    case 6444:
      switch (L(e, J(e) - 3 - (~sr(e, "!important") && 10))) {
        case 107:
          return C(e, ":", ":" + R) + e;
        case 101:
          return C(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + R + (L(e, 14) === 45 ? "inline-" : "") + "box$3$1" + R + "$2$3$1" + Y + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (L(e, r + 11)) {
        case 114:
          return R + e + Y + C(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return R + e + Y + C(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return R + e + Y + C(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return R + e + Y + e + e;
  }
  return e;
}
var yn = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case hr:
        r.return = et(r.value, r.length);
        break;
      case Jr:
        return ce([be(r, {
          value: C(r.value, "@", "@" + R)
        })], o);
      case pr:
        if (r.length)
          return Gt(r.props, function(i) {
            switch (qt(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return ce([be(r, {
                  props: [C(i, /:(read-\w+)/, ":" + Ye + "$1")]
                })], o);
              case "::placeholder":
                return ce([be(r, {
                  props: [C(i, /:(plac\w+)/, ":" + R + "input-$1")]
                }), be(r, {
                  props: [C(i, /:(plac\w+)/, ":" + Ye + "$1")]
                }), be(r, {
                  props: [C(i, /:(plac\w+)/, Y + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, En = [yn], gn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(g) {
      var k = g.getAttribute("data-emotion");
      k.indexOf(" ") !== -1 && (document.head.appendChild(g), g.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || En;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, f, l = [];
  f = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(g) {
      for (var k = g.getAttribute("data-emotion").split(" "), _ = 1; _ < k.length; _++)
        i[k[_]] = !0;
      l.push(g);
    }
  );
  var p, v = [fn, ln];
  process.env.NODE_ENV !== "production" && v.push(hn({
    get compat() {
      return $.compat;
    }
  }), mn);
  {
    var d, y = [tn, process.env.NODE_ENV !== "production" ? function(g) {
      g.root || (g.return ? d.insert(g.return) : g.value && g.type !== dr && d.insert(g.value + "{}"));
    } : an(function(g) {
      d.insert(g);
    })], P = nn(v.concat(o, y)), N = function(k) {
      return ce(en(k), P);
    };
    p = function(k, _, E, S) {
      d = E, process.env.NODE_ENV !== "production" && _.map !== void 0 && (d = {
        insert: function(c) {
          E.insert(c + _.map);
        }
      }), N(k ? k + "{" + _.styles + "}" : _.styles), S && ($.inserted[_.name] = !0);
    };
  }
  var $ = {
    key: n,
    sheet: new Lt({
      key: n,
      container: f,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return $.sheet.hydrate(l), $;
}, ur = { exports: {} }, T = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fr;
function bn() {
  if (Fr)
    return T;
  Fr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, P = e ? Symbol.for("react.suspense_list") : 60120, N = e ? Symbol.for("react.memo") : 60115, $ = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function S(c) {
    if (typeof c == "object" && c !== null) {
      var V = c.$$typeof;
      switch (V) {
        case r:
          switch (c = c.type, c) {
            case p:
            case v:
            case a:
            case i:
            case o:
            case y:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case l:
                case d:
                case $:
                case N:
                case f:
                  return c;
                default:
                  return V;
              }
          }
        case n:
          return V;
      }
    }
  }
  function D(c) {
    return S(c) === v;
  }
  return T.AsyncMode = p, T.ConcurrentMode = v, T.ContextConsumer = l, T.ContextProvider = f, T.Element = r, T.ForwardRef = d, T.Fragment = a, T.Lazy = $, T.Memo = N, T.Portal = n, T.Profiler = i, T.StrictMode = o, T.Suspense = y, T.isAsyncMode = function(c) {
    return D(c) || S(c) === p;
  }, T.isConcurrentMode = D, T.isContextConsumer = function(c) {
    return S(c) === l;
  }, T.isContextProvider = function(c) {
    return S(c) === f;
  }, T.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, T.isForwardRef = function(c) {
    return S(c) === d;
  }, T.isFragment = function(c) {
    return S(c) === a;
  }, T.isLazy = function(c) {
    return S(c) === $;
  }, T.isMemo = function(c) {
    return S(c) === N;
  }, T.isPortal = function(c) {
    return S(c) === n;
  }, T.isProfiler = function(c) {
    return S(c) === i;
  }, T.isStrictMode = function(c) {
    return S(c) === o;
  }, T.isSuspense = function(c) {
    return S(c) === y;
  }, T.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === v || c === i || c === o || c === y || c === P || typeof c == "object" && c !== null && (c.$$typeof === $ || c.$$typeof === N || c.$$typeof === f || c.$$typeof === l || c.$$typeof === d || c.$$typeof === k || c.$$typeof === _ || c.$$typeof === E || c.$$typeof === g);
  }, T.typeOf = S, T;
}
var O = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jr;
function _n() {
  return jr || (jr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, f = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, v = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, y = e ? Symbol.for("react.suspense") : 60113, P = e ? Symbol.for("react.suspense_list") : 60120, N = e ? Symbol.for("react.memo") : 60115, $ = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, k = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function S(h) {
      return typeof h == "string" || typeof h == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      h === a || h === v || h === i || h === o || h === y || h === P || typeof h == "object" && h !== null && (h.$$typeof === $ || h.$$typeof === N || h.$$typeof === f || h.$$typeof === l || h.$$typeof === d || h.$$typeof === k || h.$$typeof === _ || h.$$typeof === E || h.$$typeof === g);
    }
    function D(h) {
      if (typeof h == "object" && h !== null) {
        var me = h.$$typeof;
        switch (me) {
          case r:
            var oe = h.type;
            switch (oe) {
              case p:
              case v:
              case a:
              case i:
              case o:
              case y:
                return oe;
              default:
                var te = oe && oe.$$typeof;
                switch (te) {
                  case l:
                  case d:
                  case $:
                  case N:
                  case f:
                    return te;
                  default:
                    return me;
                }
            }
          case n:
            return me;
        }
      }
    }
    var c = p, V = v, A = l, Je = f, Re = r, Ke = d, He = a, Ce = $, q = N, H = n, re = i, Te = o, Oe = y, le = !1;
    function Pe(h) {
      return le || (le = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), de(h) || D(h) === p;
    }
    function de(h) {
      return D(h) === v;
    }
    function $e(h) {
      return D(h) === l;
    }
    function Ae(h) {
      return D(h) === f;
    }
    function Ne(h) {
      return typeof h == "object" && h !== null && h.$$typeof === r;
    }
    function Ze(h) {
      return D(h) === d;
    }
    function Xe(h) {
      return D(h) === a;
    }
    function pe(h) {
      return D(h) === $;
    }
    function he(h) {
      return D(h) === N;
    }
    function ne(h) {
      return D(h) === n;
    }
    function ve(h) {
      return D(h) === i;
    }
    function ae(h) {
      return D(h) === o;
    }
    function Qe(h) {
      return D(h) === y;
    }
    O.AsyncMode = c, O.ConcurrentMode = V, O.ContextConsumer = A, O.ContextProvider = Je, O.Element = Re, O.ForwardRef = Ke, O.Fragment = He, O.Lazy = Ce, O.Memo = q, O.Portal = H, O.Profiler = re, O.StrictMode = Te, O.Suspense = Oe, O.isAsyncMode = Pe, O.isConcurrentMode = de, O.isContextConsumer = $e, O.isContextProvider = Ae, O.isElement = Ne, O.isForwardRef = Ze, O.isFragment = Xe, O.isLazy = pe, O.isMemo = he, O.isPortal = ne, O.isProfiler = ve, O.isStrictMode = ae, O.isSuspense = Qe, O.isValidElementType = S, O.typeOf = D;
  }()), O;
}
process.env.NODE_ENV === "production" ? ur.exports = bn() : ur.exports = _n();
var xn = ur.exports, rt = xn, Sn = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, wn = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, tt = {};
tt[rt.ForwardRef] = Sn;
tt[rt.Memo] = wn;
var Rn = !0;
function Cn(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var nt = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Rn === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, Tn = function(r, n, a) {
  nt(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function On(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var Pn = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Vr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, $n = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", An = /[A-Z]|^ms/g, at = /_EMO_([^_]+?)_([^]*?)_EMO_/g, mr = function(r) {
  return r.charCodeAt(1) === 45;
}, Lr = function(r) {
  return r != null && typeof r != "boolean";
}, or = /* @__PURE__ */ on(function(e) {
  return mr(e) ? e : e.replace(An, "-$&").toLowerCase();
}), We = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(at, function(a, o, i) {
          return G = {
            name: o,
            styles: i,
            next: G
          }, o;
        });
  }
  return Pn[r] !== 1 && !mr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var Nn = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, kn = ["normal", "none", "initial", "inherit", "unset"], In = We, Dn = /^-ms-/, Mn = /-(.)/g, Yr = {};
  We = function(r, n) {
    if (r === "content" && (typeof n != "string" || kn.indexOf(n) === -1 && !Nn.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = In(r, n);
    return a !== "" && !mr(r) && r.indexOf("-") !== -1 && Yr[r] === void 0 && (Yr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(Dn, "ms-").replace(Mn, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var ot = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Se(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(ot);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return G = {
          name: n.name,
          styles: n.styles,
          next: G
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            G = {
              name: a.name,
              styles: a.styles,
              next: G
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return Fn(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = G, f = n(e);
        return G = i, Se(e, r, f);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var l = [], p = n.replace(at, function(d, y, P) {
          var N = "animation" + l.length;
          return l.push("const " + N + " = keyframes`" + P.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + N + "}";
        });
        l.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(l, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var v = r[n];
  return v !== void 0 ? v : n;
}
function Fn(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += Se(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var f = n[i];
      if (typeof f != "object")
        r != null && r[f] !== void 0 ? a += i + "{" + r[f] + "}" : Lr(f) && (a += or(i) + ":" + We(i, f) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(ot);
        if (Array.isArray(f) && typeof f[0] == "string" && (r == null || r[f[0]] === void 0))
          for (var l = 0; l < f.length; l++)
            Lr(f[l]) && (a += or(i) + ":" + We(i, f[l]) + ";");
        else {
          var p = Se(e, r, f);
          switch (i) {
            case "animation":
            case "animationName": {
              a += or(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error($n), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var Wr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, it;
process.env.NODE_ENV !== "production" && (it = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var G, zr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  G = void 0;
  var f = r[0];
  f == null || f.raw === void 0 ? (o = !1, i += Se(a, n, f)) : (process.env.NODE_ENV !== "production" && f[0] === void 0 && console.error(Vr), i += f[0]);
  for (var l = 1; l < r.length; l++)
    i += Se(a, n, r[l]), o && (process.env.NODE_ENV !== "production" && f[l] === void 0 && console.error(Vr), i += f[l]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(it, function(P) {
    return p = P, "";
  })), Wr.lastIndex = 0;
  for (var v = "", d; (d = Wr.exec(i)) !== null; )
    v += "-" + // $FlowFixMe we know it's not null
    d[1];
  var y = On(i) + v;
  return process.env.NODE_ENV !== "production" ? {
    name: y,
    styles: i,
    map: p,
    next: G,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: y,
    styles: i,
    next: G
  };
}, jn = function(r) {
  return r();
}, Vn = ee["useInsertionEffect"] ? ee["useInsertionEffect"] : !1, Ln = Vn || jn, Ge = {}.hasOwnProperty, yr = /* @__PURE__ */ ee.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ gn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (yr.displayName = "EmotionCacheContext");
yr.Provider;
var Yn = function(r) {
  return /* @__PURE__ */ Gr(function(n, a) {
    var o = At(yr);
    return r(n, o, a);
  });
}, st = /* @__PURE__ */ ee.createContext({});
process.env.NODE_ENV !== "production" && (st.displayName = "EmotionThemeContext");
var Ur = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, Wn = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return Ur(n[1]);
}, zn = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), Un = function(r) {
  return r.replace(/\$/g, "-");
}, Bn = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = Wn(n[a]);
      if (o) {
        if (zn.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return Un(o);
      }
    }
}, fr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", lr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", ct = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    Ge.call(n, o) && (a[o] = n[o]);
  if (a[fr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = Bn(new Error().stack);
    i && (a[lr] = i);
  }
  return a;
}, qn = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return nt(n, a, o), Ln(function() {
    return Tn(n, a, o);
  }), null;
}, ut = /* @__PURE__ */ Yn(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[fr], i = [a], f = "";
  typeof e.className == "string" ? f = Cn(r.registered, i, e.className) : e.className != null && (f = e.className + " ");
  var l = zr(i, void 0, ee.useContext(st));
  if (process.env.NODE_ENV !== "production" && l.name.indexOf("-") === -1) {
    var p = e[lr];
    p && (l = zr([l, "label:" + p + ";"]));
  }
  f += r.key + "-" + l.name;
  var v = {};
  for (var d in e)
    Ge.call(e, d) && d !== "css" && d !== fr && (process.env.NODE_ENV === "production" || d !== lr) && (v[d] = e[d]);
  return v.ref = n, v.className = f, /* @__PURE__ */ ee.createElement(ee.Fragment, null, /* @__PURE__ */ ee.createElement(qn, {
    cache: r,
    serialized: l,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ ee.createElement(o, v));
});
process.env.NODE_ENV !== "production" && (ut.displayName = "EmotionCssPropInternal");
var ft = ut;
function Me(e, r, n) {
  return Ge.call(r, "css") ? Le.jsx(ft, ct(e, r), n) : Le.jsx(e, r, n);
}
function Gn(e, r, n) {
  return Ge.call(r, "css") ? Le.jsxs(ft, ct(e, r), n) : Le.jsxs(e, r, n);
}
const Jn = [
  "white",
  "blackAlpha",
  "gray",
  "red",
  "orange",
  "yellow",
  "green",
  "blue",
  "cyan",
  "purple",
  "grayBlue",
  "techPurple",
  "techPink"
];
function Kn(e, r, n) {
  const a = n === "medium" ? "26px" : "40px", o = n === "medium" ? "16px" : "24px", i = Jn.indexOf(e) > -1;
  let f = r ? i ? X(`--${Q}-${e}-01`) : e : X(`--${Q}-grayBlue-06`);
  return ze`
    position: relative;
    border-radius: 16px;
    min-width: ${a};
    height: ${o};
    line-height: ${o};
    background-color: ${f};
    color: ${f};
    vertical-align: middle;
    cursor: pointer;
    box-sizing: border-box;
    border: none;
    overflow: hidden;
    padding: 0;
    outline: none;
    transition: background-color 0.2s ease-in-out;
    &:disabled {
      cursor: not-allowed;
      background-color: ${i && r ? X(`--${Q}-${e}-06`) : X(`--${Q}-grayBlue-08`)};
      color: ${i && r ? X(`--${Q}-${e}-06`) : X(`--${Q}-grayBlue-08`)};
    }
  `;
}
function Hn(e, r, n) {
  const a = e === "medium" ? "12px" : "16px", o = e === "medium" ? "2px" : "4px", i = r ? `
        left: 100%;
        margin-left: -${o};
        transform:translateX(-100%)
      ` : `left:${o}`, f = n ? "" : `box-shadow:0 1px 2px ${X(`--${Q}-blackAlpha-05`)}`;
  return ze`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    position: absolute;
    top: ${o};
    ${i};
    width: ${a};
    height: ${a};
    border-radius: 50%;
    ${f};
    background-color: ${X(`--${Q}-white-01`)};
    transition: all 0.2s ease-in-out;
  `;
}
function Zn(e, r) {
  const n = r === "medium" ? `
          font-size: 12px;
          line-height: 1
        ` : `
          font-size:14px;
          line-height: 1.14
        `, a = r === "medium" ? 6 : 8, o = r === "medium" ? 19 : 26, i = e ? `margin:0 ${o}px 0 ${a}px` : `margin:0 ${a}px 0 ${o}px`;
  return ze`
    color: ${X(`--${Q}-white-01`)};
    ${n};
    ${i};
    white-space: pre;
    transition: margin 0.2s;
  `;
}
const Br = ze`
  width: 8px;
  height: 8px;
  font-size: 8px;
  line-height: 6px;
  overflow: hidden;
`, Xn = Gr((e, r) => {
  const { colorScheme: n = "blue", disabled: a, size: o = "medium", checkedText: i = "", uncheckedText: f = "", checkedIcon: l, uncheckedIcon: p, checked: v, defaultChecked: d, onChange: y, onClick: P, ...N } = e, [$, g] = Nt(d ?? !1), k = v !== void 0 ? v : $, _ = (S) => {
    v === void 0 && g(!k), y && y(!k, S), P && P(S);
  }, E = k ? i : f;
  return Gn("button", { css: [
    Kn(n, k, o),
    kt(e)
  ], ref: r, onClick: _, disabled: a, type: "button", ...It(N), children: [Me("div", { css: Hn(o, k, a ?? !1), children: (l || p) && Me("div", { css: Br, children: k ? l : p }) }), Me("div", { css: Zn(k, o), children: Dt(E) ? Me("div", { css: Br, children: E }) : E })] });
});
Xn.displayName = "Switch";
export {
  Xn as Switch
};
//# sourceMappingURL=index.js.map
